var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 32,
    viewBox: "0 0 174 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4196 8.46539H24.5205V25.3615H29.4196V8.46539Z",
    fill: "url(#paint0_linear_1188_6634)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8949 16.9134C51.8949 22.2211 48.2207 25.6127 43.4781 25.6127C41.3741 25.6127 39.6466 24.9529 38.3904 23.5714V31.4542H33.4912V8.46537H38.1704V10.4128C39.3954 8.93656 41.2168 8.21411 43.4781 8.21411C48.2207 8.21411 51.8949 11.6057 51.8949 16.9134ZM46.9331 16.9134C46.9331 13.993 45.0803 12.2342 42.6304 12.2342C40.1812 12.2342 38.3277 13.993 38.3277 16.9134C38.3277 19.8338 40.1805 21.5926 42.6304 21.5926C45.0803 21.5926 46.9331 19.8338 46.9331 16.9134Z",
    fill: "#13304C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9513 15.6885V25.3615H67.0522V16.4423C67.0522 13.7098 65.7959 12.4535 63.6293 12.4535C61.274 12.4535 59.5778 13.8984 59.5778 17.0074V25.3615H54.6787V2.05872H59.5778V10.2242C60.8968 8.90527 62.7808 8.21414 64.9482 8.21414C68.937 8.21414 71.9513 10.5381 71.9513 15.6885Z",
    fill: "#13304C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5416 18.295H79.7596C80.2308 20.399 82.0209 21.6866 84.5961 21.6866C86.3862 21.6866 87.6738 21.1528 88.8361 20.0538L91.4426 22.8802C89.8725 24.6703 87.5172 25.6127 84.4708 25.6127C78.6293 25.6127 74.8291 21.9378 74.8291 16.9134C74.8291 11.857 78.6919 8.21411 83.8423 8.21411C88.8041 8.21411 92.6356 11.5431 92.6356 16.9761C92.6356 17.3526 92.5729 17.8864 92.5416 18.295ZM79.6969 15.4372H88.0197C87.6745 13.3019 86.0723 11.9196 83.8743 11.9196C81.6437 11.9196 80.0422 13.2706 79.6969 15.4372Z",
    fill: "#13304C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.076 8.21411V12.7367C105.668 12.7054 105.354 12.6741 104.977 12.6741C102.276 12.6741 100.486 14.1503 100.486 17.3846V25.3615H95.5869V8.46537H100.266V10.6954C101.46 9.06184 103.47 8.21411 106.076 8.21411Z",
    fill: "#13304C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2737 20.2807C14.2388 20.9015 13.0277 21.2586 11.7339 21.2586C10.4407 21.2586 9.22896 20.9015 8.19401 20.2807C7.221 19.6967 6.40389 18.8796 5.82203 17.9066C5.2012 16.8717 4.84417 15.662 4.84417 14.3688C4.84417 13.0757 5.2012 11.8639 5.82203 10.829C6.40598 9.85599 7.22309 9.03888 8.1961 8.45703C9.23105 7.83619 10.4407 7.47915 11.7339 7.47915C13.027 7.47915 14.2367 7.83619 15.2716 8.45703C16.2446 9.03888 17.0617 9.85599 17.6457 10.829L21.1333 7.34134C20.4589 6.44211 19.6606 5.64171 18.7593 4.96937C16.8001 3.50151 14.3675 2.6322 11.7339 2.6322C9.10021 2.6322 6.66767 3.50151 4.70843 4.96937C3.80781 5.6424 3.00881 6.44211 2.33508 7.34134C0.868611 9.30058 0 11.7331 0 14.3688C0 17.0046 0.869307 19.4364 2.33508 21.3943C3.00951 22.2949 3.80781 23.0939 4.70843 23.7662C6.66767 25.2341 9.10021 26.1027 11.7339 26.1027C14.3675 26.1027 16.8001 25.2334 18.7593 23.7662C19.6599 23.0932 20.4589 22.2949 21.1333 21.3943L17.6457 17.9066C17.0638 18.8803 16.2467 19.6967 15.2737 20.2807Z",
    fill: "#13304C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9041 1.3467C27.8358 0.278338 26.1041 0.279035 25.0365 1.34739C23.9695 2.41506 23.9695 4.14601 25.0372 5.21368C26.1048 6.28134 27.8351 6.28134 28.9034 5.21437C29.9718 4.14671 29.9718 2.41506 28.9041 1.3467Z",
    fill: "url(#paint1_linear_1188_6634)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.576 8.71667C115.718 8.71667 113.489 9.8783 112.295 11.889V8.84196H110.16V25.3615H112.389V16.6935C112.389 12.9254 114.62 10.726 118.168 10.726C121.309 10.726 123.131 12.5161 123.131 16.0024V25.3615H125.36V15.7825C125.359 11.0406 122.596 8.71667 118.576 8.71667Z",
    fill: "url(#paint2_linear_1188_6634)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.581 17.5099C141.581 21.278 139.415 23.5087 135.96 23.5087C132.819 23.5087 130.997 21.7186 130.997 18.201V8.84192H128.767V18.421C128.767 23.1642 131.532 25.5188 135.738 25.5188C138.376 25.5188 140.513 24.3572 141.675 22.3464V25.3622H143.811V8.84192H141.581V17.5099V17.5099Z",
    fill: "url(#paint3_linear_1188_6634)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.416 23.5087L173.812 10.3181V8.84192H160.747V10.726H170.954L160.559 23.8846V25.3615H174V23.5087H163.416Z",
    fill: "url(#paint4_linear_1188_6634)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.351 5.23035H150.123V8.84189H147.171V10.726H150.123V20.7136V25.3615H152.351V24.9619V10.726H157.377V8.84189H152.351V5.23035Z",
    fill: "url(#paint5_linear_1188_6634)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1188_6634",
    x1: 27.0922,
    y1: -3.91981,
    x2: 26.9022,
    y2: 28.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1188_6634",
    x1: 27.0127,
    y1: -3.92028,
    x2: 26.8227,
    y2: 28.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1188_6634",
    x1: 117.879,
    y1: -3.38887,
    x2: 117.689,
    y2: 29.1058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1188_6634",
    x1: 136.408,
    y1: -3.28054,
    x2: 136.218,
    y2: 29.2142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1188_6634",
    x1: 167.441,
    y1: -3.09906,
    x2: 167.251,
    y2: 29.3956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1188_6634",
    x1: 152.35,
    y1: -3.18735,
    x2: 152.16,
    y2: 29.3074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75BC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6bfc2441a03133d6d8a63c2e2fcbffb5.svg";
export { ForwardRef as ReactComponent };